import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	async getCommCodes(codeType) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//고품회수목록 조회
	getRtnPartMstList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (
			searchParams.rptpSt !== undefined ||
			searchParams.clctWay !== undefined ||
			searchParams.causPartNo !== undefined ||
			searchParams.srchMm !== undefined ||
			searchParams.startDd !== undefined ||
			searchParams.endDd !== undefined ||
			searchParams.dlrCpnyCd !== undefined
		) {
			queryStr = objectToQuerystring({
				rptpSt: searchParams.rptpSt /* 고품회수상태 */,
				clctWay: searchParams.clctWay /* 회수방법 */,
				causPartNo: searchParams.causPartNo /*원인부품번호 */,
				srchMm: searchParams.srchMm /*고품회수_조건일*/,
				startDd: searchParams.startDd /*to*/,
				endDd: searchParams.endDd /*from*/,
				dlrCpnyCd: searchParams.dlrCpnyCd,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rtnParts` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	//고품회수목록 상세 조회
	getRtnPartInfo(param) {
		const roNo = param.roNo;
		const rptpNo = param.rptpNo;
		const aplcId = param.aplcId;
		const aplcDept = param.aplcDept;
		return client
			.get(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rtnPart/roNo/${roNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// 고품회수신청 저장
	async saveRtnPartInfo({ saveParams }) {
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rtnPart/status/1`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//고품회수상태 수정
	async updateRtnPartSt({ rptpNo, updateParams }) {
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rptpSt/status/2/rptpNo/${rptpNo}`, updateParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//고품출고정보 수정
	async updateRtnPartInfo({ saveParams }) {
		const rptpNo = saveParams.rptpNo;
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rtnRptp/status/2/rptpNo/${rptpNo}`, saveParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	//고품회수신청 완료
	async updateRtnPartCmpl({ rptpNo, updateParams }) {
		try {
			const response = await client.post(`${BASE_URL}/mqy/ceqi/rtnPartMst/v1/rptpStCmpl/status/2/rptpNo/${rptpNo}`, updateParams);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
